import useSwr from 'hooks/useSwr';
import { getBusinessConfigurations } from 'services/business-settings.service';

export const SUBSCRIPTION_ENABLED_KEY = 'subscription_enabled';

/**
 * Whether this business has turned on subscription products (Account Settings toggle,
 * business_configurations key "subscription_enabled") — gates the top-level Subscription nav
 * item. Config values are stored as strings, hence the explicit 'true' check.
 */
export function useSubscriptionEnabled() {
  const fetcher = async () => getBusinessConfigurations(SUBSCRIPTION_ENABLED_KEY);
  const { data, isLoading } = useSwr({ url: '/business-accounts/configurations:subscription_enabled', fetcher });

  return {
    isSubscriptionEnabled: data?.configurations?.[SUBSCRIPTION_ENABLED_KEY] === 'true',
    isLoading,
  };
}
